// Central site imagery + editorial copy (Saudi/Riyadh focused).
export const IMG = {
  heroRiyadh: "https://images.unsplash.com/photo-1784637729389-f24e1d2a8b22?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  skylineSunset: "https://images.unsplash.com/photo-1758798219572-512a03a60ce0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  cityNight: "https://images.unsplash.com/photo-1663900108404-a05e8bf82cda?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  kafdAerial: "https://images.unsplash.com/photo-1674386491555-5b92161e4d04?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  kafdTower: "https://images.unsplash.com/photo-1669101564304-1da32c23f8ec?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  boardroomView: "https://images.unsplash.com/photo-1779700210487-a01758a3c55a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  kingdomDay: "https://images.unsplash.com/photo-1651428016256-70b39e3483da?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  kingdomSunset: "https://images.unsplash.com/photo-1506795213373-430e921fe2ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  faisaliah: "https://images.unsplash.com/photo-1570724546132-6a61bb3c3894?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  jeddahCorniche: "https://images.pexels.com/photos/34744917/pexels-photo-34744917.jpeg?auto=compress&cs=tinysrgb&w=2000",
  jeddahWater: "https://images.unsplash.com/photo-1785087363369-f07860094165?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  riyadhHighway: "https://images.unsplash.com/photo-1742084312070-0a952dff8b8c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  riyadhNight: "https://images.unsplash.com/photo-1738410775719-9f237adb266d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  madinah: "https://images.pexels.com/photos/34810060/pexels-photo-34810060.jpeg?auto=compress&cs=tinysrgb&w=2000",
  // aliases kept for existing references (now Saudi imagery)
  boardroom: "https://images.pexels.com/photos/34744917/pexels-photo-34744917.jpeg?auto=compress&cs=tinysrgb&w=2000",
  abstractGold: "https://images.unsplash.com/photo-1506795213373-430e921fe2ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  geometric: "https://images.unsplash.com/photo-1738410775719-9f237adb266d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

export const NAV = [
  { label: "About", to: "/about" },
  { label: "Investment", to: "/investment" },
  { label: "Partnerships", to: "/partnerships" },
  { label: "Saudi Arabia", to: "/saudi-arabia" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Insights", to: "/insights" },
];

export const INTERSECTIONS = [
  { key: "CAPITAL", text: "Connecting investment capital with credible opportunities." },
  { key: "VENTURES", text: "Building, backing and scaling businesses with long-term potential." },
  { key: "PARTNERSHIPS", text: "Creating commercial alliances that expand capabilities and market access." },
  { key: "SAUDI ARABIA", text: "Providing access to one of the world's most dynamic economic transformations." },
];

export const WHAT_WE_DO = [
  { no: "01", label: "Venture Capital", headline: "Investing in ideas with the potential to scale.",
    body: "We identify, evaluate and participate in high-potential ventures where strategic capital, Saudi market access and partnership development can accelerate growth.",
    cta: "Investment Strategy", to: "/investment" },
  { no: "02", label: "Venture Building", headline: "Turning opportunities into companies.",
    body: "Intersect develops ventures around validated market opportunities, assembling the capital, partnerships, operating capabilities and commercial relationships necessary for growth.",
    cta: "Explore Ventures", to: "/portfolio" },
  { no: "03", label: "Strategic Partnerships", headline: "Relationships that create enterprise value.",
    body: "We bring together organizations with complementary capabilities to create strategic alliances, joint ventures and commercial partnerships.",
    cta: "Our Partnership Model", to: "/partnerships" },
  { no: "04", label: "Saudi Market Expansion", headline: "Connecting global capability with Saudi opportunity.",
    body: "Intersect works with international companies, investors and innovators seeking strategic relationships, commercial opportunities and long-term participation in the Saudi economy.",
    cta: "Saudi Arabia", to: "/saudi-arabia" },
];

export const PRINCIPLES = [
  { no: "01", title: "Strategic Value", text: "Capital should create more than financial participation." },
  { no: "02", title: "Market Access", text: "Strong companies become stronger when they gain access to the right markets." },
  { no: "03", title: "Partnership", text: "Relationships can be one of the most valuable forms of capital." },
  { no: "04", title: "Execution", text: "Opportunities only create value when they can be executed." },
  { no: "05", title: "Long-Term Thinking", text: "We seek durable businesses rather than short-term transactions." },
];

export const VALUES = ["Long-Term Thinking", "Relationships", "Integrity", "Entrepreneurship", "Execution", "Curiosity"];

export const NETWORK_NODES = ["Investors", "Founders", "Corporates", "Family Offices", "Institutions", "Technology", "Saudi Arabia", "Global Markets"];

export const PARTNERSHIP_MODELS = [
  "Strategic Alliances", "Joint Ventures", "Market Partnerships", "Technology Partnerships",
  "Distribution Partnerships", "Corporate Ventures", "Investment Partnerships",
  "Government & Institutional Collaboration", "Cross-Border Partnerships",
];

export const PARTNERSHIP_FLOW = [
  "Opportunity", "Identify Strategic Participants", "Align Interests",
  "Define Commercial Model", "Build Partnership", "Execute",
];

export const INVESTMENT_STAGES = [
  { title: "Early Stage", text: "Backing founders at the formation of ambitious companies." },
  { title: "Growth Stage", text: "Supporting proven businesses entering their scaling phase." },
  { title: "Strategic Investments", text: "Capital paired with market access and relationships." },
  { title: "Joint Ventures", text: "Co-building new companies around validated opportunities." },
  { title: "Corporate Ventures", text: "Partnering with corporates to create new business lines." },
  { title: "Special Situations", text: "Selective participation where structure creates value." },
];

export const INVESTMENT_CRITERIA = [
  "Strong founders", "Large addressable markets", "Saudi market relevance",
  "Scalable business models", "Technology differentiation", "Strategic partnership potential",
  "Regional expansion opportunity", "Clear value creation strategy",
];

export const CONTACT_REASONS = [
  "Seeking Investment", "Presenting an Investment Opportunity", "Exploring Saudi Arabia",
  "Looking for a Saudi Partner", "Looking for an International Partner", "Exploring a Joint Venture",
  "Representing an Investment Fund", "Representing a Family Office", "Other",
];

export const INSIGHT_CATEGORIES = ["All", "Investment", "Saudi Arabia", "Venture Capital", "Markets", "Partnerships", "Technology"];
export const PORTFOLIO_FILTERS = ["All", "Investment", "Venture", "Partnership", "Joint Venture"];

export const SAUDI_CENTERS = [
  { name: "Riyadh", x: 55, y: 52 },
  { name: "Jeddah", x: 28, y: 62 },
  { name: "Eastern Province", x: 78, y: 45 },
  { name: "NEOM / Northwest", x: 22, y: 24 },
  { name: "Makkah Region", x: 30, y: 66 },
  { name: "Madinah", x: 33, y: 46 },
];
